import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FirefrontLogo } from './FirefrontLogo.tsx';
import { GameContext } from '../contexts/GameContext.tsx';
import { PortfolioContext } from '../contexts/PortfolioContext.tsx';
import { FIRESWEEPER_CONTAINER, FIRESWEEPER_SURVIVOR } from '../constants/gameModes.ts';
import { useUtcCountdown } from '../hooks/useUtcCountdown.ts';
import { formatElapsedSeconds, useGameTimer } from '../hooks/useGameTimer.ts';

export default function Navigation() {
  const location = useLocation();
  const gameContext = useContext(GameContext);
  const portfolioContext = useContext(PortfolioContext);
  const { countdown } = useUtcCountdown();

  const isContainerGame = location.pathname === FIRESWEEPER_CONTAINER.path;
  const isSurvivorGame = location.pathname === FIRESWEEPER_SURVIVOR.path;
  const isGameRoute = isContainerGame || isSurvivorGame;
  const isHome = location.pathname === '/';

  const modeName = isContainerGame
    ? FIRESWEEPER_CONTAINER.subtitle
    : isSurvivorGame
      ? FIRESWEEPER_SURVIVOR.subtitle
      : null;

  const showSurvival =
    isContainerGame &&
    gameContext?.isGameStarted &&
    !gameContext?.isGameOver;

  const elapsedSeconds = useGameTimer(
    gameContext?.gameStartTime ?? 0,
    Boolean(showSurvival)
  );

  const showSurvivorStart =
    isSurvivorGame && portfolioContext?.phase === 'selecting';

  const navActions =
    showSurvival || showSurvivorStart ? (
      <div className="nav-actions">
        {showSurvival && gameContext && (
          <div
            className="nav-status nav-game-stats"
            aria-label={`${gameContext.survivalPercentage.toFixed(1)}% forest saved, ${formatElapsedSeconds(elapsedSeconds)} elapsed`}
          >
            <span className="nav-game-stats-survival">
              {gameContext.survivalPercentage.toFixed(1)}%
            </span>
            <span className="nav-game-stats-sep" aria-hidden>
              ·
            </span>
            <span className="nav-game-stats-timer">
              {formatElapsedSeconds(elapsedSeconds)}
            </span>
          </div>
        )}
        {showSurvivorStart && portfolioContext && (
          <button
            type="button"
            className="btn btn-primary btn-nav"
            disabled={portfolioContext.selectedTiles.length === 0}
            onClick={portfolioContext.startSimulation}
          >
            Start
          </button>
        )}
      </div>
    ) : null;

  return (
    <nav className={`nav${isGameRoute ? ' nav--game' : ''}`}>
      <div className="nav-container">
        <div className="nav-left">
          <Link to="/" className="nav-brand" aria-label="Firesweeper home">
            <div className="brand-container">
              <FirefrontLogo className="nav-logo" />
              <span>{isGameRoute ? modeName : 'Firesweeper'}</span>
            </div>
          </Link>
        </div>

        <div className="nav-right">
          {isHome && (
            <div className="nav-countdown" aria-label={`Daily puzzle resets in ${countdown}`}>
              {countdown}
            </div>
          )}
          {navActions}
        </div>
      </div>
    </nav>
  );
}
